export default __webpack_public_path__ + "spain.009218b2.png";